export default {
    title: 'Painel administrador',
    welcome: 'Conheça',

    settings: 'Configurações',
    logout: 'Sair',
    login: 'Entrar',
}